export const REQUEST_BEGIN = '@REDUX_REST_API/REQUEST_BEGIN'
export const REQUEST_SUCCESS = '@REDUX_REST_API/REQUEST_SUCCESS'
export const REQUEST_FAIL = '@REDUX_REST_API/REQUEST_FAIL'
export const REQUEST_RESET_STATE = '@REDUX_REST_API/REQUEST_RESET_STATE'

export const requestBegin = (requestName: string) => ({
  type: `${REQUEST_BEGIN}/${requestName}`
})

export const requestSuccess = <T> (requestName: string, data: T) => ({
  type: `${REQUEST_SUCCESS}/${requestName}`,
  payload: data
})

export const requestFail = (requestName: string, error: object) => ({
  type: `${REQUEST_FAIL}/${requestName}`,
  payload: error
})

export const resetApiOperationState = (requestName: string) => ({
  type: `${REQUEST_RESET_STATE}/${requestName}`
})
